import { render, staticRenderFns } from "./plan_is_ready.vue?vue&type=template&id=5dee2dfe&scoped=true"
import script from "./plan_is_ready.vue?vue&type=script&lang=js"
export * from "./plan_is_ready.vue?vue&type=script&lang=js"
import style0 from "./plan_is_ready.vue?vue&type=style&index=0&id=5dee2dfe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dee2dfe",
  null
  
)

export default component.exports